import $ from "jquery"
import { trace } from "./../shared/helpers.js"
import Masonry from "masonry-layout"
import imagesLoaded from "imagesloaded"

const UMasonry = {

  layoutMasonry(index, grid) {
    if (grid.msnry) {
      trace("layout", grid);
      grid.msnry.layout();
    }
  },

  destroyMasonry(index, grid) {
    if (grid.msnry) {
      grid.msnry.destroy();
    }
  },
  refreshMasonry(index, grid) {
    this.destroyMasonry(index, grid);
    this.initMasonry(index, grid);
  },
  appended($grid) {
    const msnry = new Masonry( $grid.get(0), {
      itemSelector: '.masonry-item',
      columnWidth: '.masonry-item',
      stamp: '.corner-stamp'
    }); 
  },
  initMasonry(index, grid) {
    let $grid = $(grid);
    if ($grid.length) {
      this.msnry = new Masonry( $grid.get(0), {
        itemSelector: '.masonry-item',
        columnWidth: '.masonry-item',
        stamp: '.corner-stamp'
      });      
      this.imgsL = new imagesLoaded($grid);
      this.imgsL.on("progress", ()=>{
        this.msnry.layout();
      });
      trace("masonry: ", this.msnry);
    }
  },
  
  refresh() {
    $('.masonry-loader').each( this.refreshMasonry.bind(this) );
  },

  layout() {
    $('.masonry-loader').each( this.layoutMasonry.bind(this) );
  },

  onMoreMasonryClick(e) {
    e.preventDefault();
    trace("more masonry click");
    let $btn = $(e.currentTarget);
    if (!$btn.data("target") || !$btn.data("items")) {
      return false;
    }
    let $target = $($btn.data("target"));
    let $items = $($btn.data("items")).find(".masonry-item");
    if (!$target.length || !$items.length) {
      return false;
    }
    trace($items.length);
    $target.append($items);
    let msnry = new Masonry( $target.get(0) );
    msnry.layout();
    $btn.css("display", "none");
    
  },

  init() {
    // init masonry?
    $('.masonry-loader').each( this.initMasonry );    
    // init more masonry
    $('body').on('click', '.more-masonry', this.onMoreMasonryClick);
  }

}

export default UMasonry;